<template>
  <b-container fluid class="p-2">
    <b-row class="min-vh-100-nf">
      <b-col cols="12" lg="3" md="4" v-if="!sensorActive" class="order-md-1 order-lg-0 order-1 d-lg-block d-md-none">
        <Slider class="mb-2" />
      </b-col>
      <b-col cols="12" :lg="sensorActive ? '12' : '7'" :xl="sensorActive ? '12' : '7'" md="12" :class="sensorActive ? '' : ''" class="order-md-0 order-lg-1 mb-lg-0 mb-4 order-0">
        <Contents ref="content"/>
      </b-col>
      <b-col v-if="!sensorActive" cols="12" lg="2" class="d-flex align-items-start order-2">
        <RightMenu :main="callSaved" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { BRow, BCol, BContainer } from 'bootstrap-vue'
import Slider from '@/views/frontend/components/Slider.vue'
import Contents from '@/views/frontend/components/numbers/Contents.vue'
import RightMenu from '@/views/frontend/components/RightMenu.vue'

export default {
  name: 'Main',
  components: {
    BRow,
    BCol,
    BContainer,
    Slider,
    Contents,
    RightMenu,
  },
  methods: {
    callSaved(n) {
      if (n && this.$refs.content.$refs.searchForm.$refs[n]) {
        this.$refs.content.$refs.searchForm.$refs[n][0].callSavedFromOut()
      }
    },
  },
  data() {
    return {
      sensorActive: false,
    }
  },
  created() {
    if (this.$route.query.sensor && this.$route.query.sensor === 'active') {
      this.sensorActive = true
    } else {
      this.sensorActive = false
    }
  },
}
</script>

<style scoped>

</style>
